import { useEffect, useState } from 'react'

export const useJobSalaryPillFormat = (job) => {
  const [formatSalary, setformatSalary] = useState('')
  const minSalary = job?.salaryRange?.min?.toString()
  const maxSalary = job?.salaryRange?.max?.toString()

  useEffect(() => {
    const regex = /\B(?=(\d{3})+(?!\d))/g
    let content = ''

    if (job?.salaryRange?.show) {
      if (minSalary !== '' && maxSalary === '') {
        content = `${job?.salaryRange.currency} ${minSalary.replace(regex, ',')} ${job?.salaryRange.frequency}`
      } else if (maxSalary !== '' && minSalary === '') {
        content = `${job?.salaryRange.currency} ${maxSalary.replace(regex, ',')} ${job?.salaryRange.frequency}`
      } else if (minSalary !== '' && maxSalary !== '') {
        content = `${job?.salaryRange.currency} ${minSalary.replace(regex, ',')} - ${maxSalary.replace(regex, ',')} ${job?.salaryRange.frequency}`
      }
    }

    setformatSalary(content)
  }, [job])

  return { formatSalary } as const 
}
